import UserAPI from '../api/user'

const FETCHING_USER = 'FETCHING_USER'
const FETCHING_USER_SUCCESS = 'FETCHING_USER_SUCCESS'
const FETCHING_USER_ERROR = 'FETCHING_USER_ERROR'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: null,
    user: null
  },
  getters: {
    isLoading (state) {
      return state.isLoading
    },
    hasError (state) {
      return state.error !== null
    },
    error (state) {
      return state.error
    },
    user (state) {
      return state.user
    },
    hasUser (state) {
      return state.user !== null
    }
  },
  mutations: {
    [FETCHING_USER] (state) {
      state.isLoading = true
      state.error = null
      state.user = null
    },
    [FETCHING_USER_SUCCESS] (state, data) {
      state.isLoading = false
      state.error = null
      state.user = data
    },
    [FETCHING_USER_ERROR] (state, error) {
      state.isLoading = false
      state.error = error
      state.user = null
    }
  },
  actions: {
    async fetch ({ commit }) {
      commit(FETCHING_USER)
      try {
        let response = await UserAPI.userData()
        commit(FETCHING_USER_SUCCESS, response.data)
        return response.data
      } catch (error) {
        commit(FETCHING_USER, error)
        return null
      }
    }
  }
}
